/** @jsx jsx */
/* eslint-disable no-use-before-define,jsx-a11y/anchor-is-valid */
import { jsx } from '@emotion/core'
import { sectionCss } from './style'
import React from 'react'
import { getState, openWindow, icons } from '../twd'

const items = require('./education.json')

const state = getState('municipals.education', {
    tab: 'getting-started'
})

export default () => {
    const [tab, setTab_] = React.useState(state.value.tab || 'getting-started')
    const setTab = React.useCallback((m) => {
        state.set({tab:m})
        setTab_(m)
    }, [])

    const tabItems = items[tab] || []

    return (
    <React.Fragment>
    <div id='msrb-municipal-market-education' className="vertical-offset-sm"></div>
    <div className="container vertical-offset-sm" css={sectionCss}>
    <div className="row vertical-offset-sm"></div>

        <div className="row"><div className="col-xs-12">
            <h3 className="medium-header">MSRB Municipal Market Education</h3>
            <p>
            The Municipal Securities Rulemaking Board (MSRB), the self-regulatory
            organization that promotes a fair and efficient municipal bond market,
            provides free resources to learn about municipal bonds and the municipal
            securities market.
            The MSRB operates the free Electronic Municipal Market Access (EMMA®)
            website to provide public access to municipal bond data and disclosures.
            The below MSRB resources and more are available at the Municipal Securities
            Rulemaking Board’s website, <a target="blank" href="https://www.msrb.org">www.msrb.org</a>.
            </p>
        </div></div>

        <div className="row"><div className="col-xs-12 vertical-offset-sm">
        <div
            data-name='municipals-market-educations-nav-tabs'
            className="nav-tabs">
            <ul>
                <li className={tab==='getting-started' ? 'active' : ''}>
                <button
                    data-name='municipals-market-educations-getting-started-nav-tab'
                    className="subhead"
                    onClick={() => setTab('getting-started')}>Getting Started</button>
                </li>

                <li className={tab==='the-municipal-market' ? 'active' : ''}>
                <button
                    data-name='municipals-market-educations-the-municipal-market-nav-tab'
                    className="subhead"
                    onClick={() => setTab('the-municipal-market')}>The Municipal Market</button>
                </li>

            </ul>
            </div>
        </div></div>
        {
            tabItems.map( (a, i) => {
                let [icon, text, url] = a
                return <div key={i} className="row vertical-offset-sm">
                    <div className="col-md-12">
                    {icons[icon]}<a href='#'
                        data-name='municipals-market-educations-item'
                        className="tiny-header"
                        style={{
                            paddingLeft:'10px',
                            color:'var(--primary-base-color)',
                            cursor:'pointer'
                        }}
                        onClick={() => onUrl({url})}
                    >{text}</a>
                    </div></div>
            })
        }


    </div>
    </React.Fragment>)
}

const onUrl = ({url}) => {
    openWindow(url, '_blank')
}

